document.addEventListener('product:variant-change', (event) => {
    const purl = event.detail.producturl;
    const selectedvariant = event.detail.variant;
    let url = "";
    if (typeof productUrl !== 'undefined') url = productUrl;

    if(purl && purl=== url && filterTag){
        for (let i = 0; i < 3; i++) {
            if(selectedvariant[`option${i}`] != null){
                if(availableColors.includes(selectedvariant[`option${i}`])){
                    console.log(selectedvariant[`option${i}`]);
                    loadGWWProducts(filterTag, selectedvariant[`option${i}`]);
                }
            }
        }
    } else {
        const slides = document.querySelectorAll('#Product-Drawer-Content .product-quick-images .product-quick-images__slide');
        slides.forEach(slide => {
            const isNotEmpty = slide.querySelector('.product-single__media')
            if(!isNotEmpty) {
                //remove slide
                slide.remove();
            }
            slide.style.display = 'none';
        });
        let color= "";
        for (let i = 0; i < 3; i++) {
            if(selectedvariant[`option${i}`] != null){
                const colorsElement = document.querySelector('#available-colors');
                if(!colorsElement) return;
                let checkedColors = colorsElement.getAttribute('data-color').split(',');
                if(checkedColors.includes(selectedvariant[`option${i}`])){
                    color = selectedvariant[`option${i}`];
                }
            }
        }
        const slidesForShow = document.querySelectorAll(`#Product-Drawer-Content .product-quick-images .product-quick-images__slide[data-color="${color}"]`);
        slidesForShow.forEach(slide => {
            slide.style.display = 'block';
        });
    }

});

document.addEventListener('quick-view:open', function(event) {

    const color = event.detail.quickview_button.getAttribute('data-color');
    let radioButton = document.querySelector('#Product-Drawer-Content').querySelector(`.product-form__input--color > input[value="${color}"]`);
    if (!radioButton) radioButton = document.querySelector('#Product-Drawer-Content').querySelectorAll(`.product-form__input--color > input`)[0];
    if (!radioButton) return;
    radioButton.click();
    const changeEvent = new Event('change', { bubbles: true });
    radioButton.dispatchEvent(changeEvent);
});